const getURL = (location.pathname).indexOf('default.aspx');
const baseUrl = SITEBASEURL + 'p/tickets';

if (getURL >= 0 || location.pathname == '/') {
  window.location = baseUrl;
}

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  $('.header-logo').attr('href', '' + baseUrl);
});
